export const PROVIDER_DISPLAY_NAME = {
  clever_api: 'Clever',
  oneroster_api: 'OneRoster API',
  tci_csv: 'TCI CSV'
};
